// theirs
import { motion } from 'framer-motion'
import classNames from 'classnames'

// ours
import { ContentDataModel } from '../../../interfaces'
import {
    textAtTheTopOfImageBaseClass,
    StyledTextAtTheTopOfImage,
} from './style'
import {
    appendLocationMultiple,
    appendLocationSingle,
    appendSizes,
} from '../../../utils/append-location'
import { animationVariants } from '../../../animations'

export interface TextAtTheTopOfImageProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
}

const TextAtTheTopOfImage = ({
    className,
    testId,
    content,
    animationControls,
}: TextAtTheTopOfImageProps) => {
    return (
        <StyledTextAtTheTopOfImage
            className={classNames(textAtTheTopOfImageBaseClass, className)}
            data-testid={testId}
            content={content}
        >
            {content.contensBackgroundIsStaggered && (
                <motion.div
                    variants={animationVariants.backgroundMaskContainer}
                    initial="hidden"
                    animate={animationControls}
                    className="content-mask"
                >
                    <motion.div
                        variants={animationVariants.backgroundMaskItem}
                        className="mask-0"
                        key={'mask-0'}
                    />
                    <motion.div
                        variants={animationVariants.backgroundMaskItem}
                        className="mask-1"
                        key={'mask-1'}
                    />
                    <motion.div
                        variants={animationVariants.backgroundMaskItem}
                        className="mask-2"
                        key={'mask-2'}
                    />
                    <motion.div
                        variants={animationVariants.backgroundMaskItem}
                        className="mask-3"
                        key={'mask-3'}
                    />
                </motion.div>
            )}

            <div className="content-outer">
                <div className="content-inner">
                    {content.contentText && (
                        <motion.div
                            variants={animationVariants.paragraphContainer}
                            initial="hidden"
                            animate={animationControls}
                            className="text-wrapper"
                        >
                            <p>
                                {content.contentText
                                    .replace(/<\/br>/gi, ' </br> ') //
                                    .replace(/<i>/gi, ' <i>')
                                    .replace(/<\/i>/gi, '</i> ')
                                    .replace(/<b>/gi, ' <b>')
                                    .replace(/<\/b>/gi, '</b> ')
                                    .replace(/\s\s+/g, ' ')
                                    .split(' ')
                                    .map((elements, index) => {
                                        return elements === '</br>' ? (
                                            <br key={index} />
                                        ) : (
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    fontWeight:
                                                        elements.includes('<b>')
                                                            ? 'bold'
                                                            : undefined,
                                                    fontStyle:
                                                        elements.includes('<i>')
                                                            ? 'italic'
                                                            : undefined,
                                                }}
                                                key={index}
                                            >
                                                <motion.span
                                                    variants={
                                                        animationVariants.paragraphItem
                                                    }
                                                >
                                                    {`${elements
                                                        .replace(/<\/br>/gi, '')
                                                        .replace(/<i>/gi, '')
                                                        .replace(/<\/i>/gi, '')
                                                        .replace(/<b>/gi, '')
                                                        .replace(
                                                            /<\/b>/gi,
                                                            ''
                                                        )} `}
                                                </motion.span>
                                            </span>
                                        )
                                    })}
                            </p>
                        </motion.div>
                    )}
                    {content.contentPicture &&
                        content.contentPicture.map((picture, index) => (
                            <motion.div
                                key={index}
                                variants={animationVariants.singleImage}
                                initial="hidden"
                                animate={animationControls}
                                className="text-wrapper"
                            >
                                <picture
                                    key={index}
                                    className={picture.contentPictureClass}
                                    data-testid={picture.contentPictureTestId}
                                >
                                    <img
                                        src={appendLocationSingle(
                                            'images',
                                            picture.contentPictureImageSource
                                        )}
                                        alt={
                                            picture.contentPictureImageAlternateText
                                        }
                                        {...(picture.contentPictureSource && {
                                            srcSet: appendLocationMultiple(
                                                'images',
                                                picture.contentPictureSource
                                            ),
                                            sizes: appendSizes(
                                                picture.contentPictureSource
                                            ),
                                        })}
                                    />
                                </picture>
                            </motion.div>
                        ))}
                </div>
            </div>
        </StyledTextAtTheTopOfImage>
    )
}

export default TextAtTheTopOfImage
